import React, { useContext } from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import { useInternalTranslation, useTranslation } from './useTranslation';
import { InitializedTranslationsContext } from './createTranslationsPageProvider';

const replaceArgsWithPlaceholderAndTag = (
  argsWithTag,
  argsWithPlaceholder = {}
) => {
  Object.keys(argsWithTag).forEach(
    (arg, idx) => (argsWithPlaceholder[arg] = `|IDX:${idx}|`)
  );
  return argsWithPlaceholder;
};

const replaceTranslationWithTags = (
  defaultTransWithPlaceholder,
  argsWithPlaceholder
) => {
  let finalDefaultKey = defaultTransWithPlaceholder;
  Object.keys(argsWithPlaceholder).forEach((arg) => {
    finalDefaultKey = finalDefaultKey.replace(
      argsWithPlaceholder[arg],
      `<${arg}>{{${arg}}}</${arg}>`
    );
  });
  return finalDefaultKey;
};

/*
 * i18nKey = key.example
 * keyTranslation: "The discount is around {{discount}} and can be used up to {{period}} days"
 * values: {discount: 35, period: 90}
 * components: {
 *   discount: <Money currency={currency} size="tiny"/>
 * }
 * */
const TranslationInterpolation = ({
  children,
  i18nKey,
  values,
  components,
}) => {
  const initialized = useContext(InitializedTranslationsContext);
  const { ready } = useInternalTranslation();
  const { t } = useTranslation();

  const argsWithPlaceholder = replaceArgsWithPlaceholderAndTag(components);

  const defaultTransWithPlaceholder = t(i18nKey, {
    ...values,
    ...argsWithPlaceholder,
  });
  const defaultTrans =
    replaceTranslationWithTags(
      defaultTransWithPlaceholder,
      argsWithPlaceholder
    ) || '';

  return initialized && ready ? (
    <Trans defaults={defaultTrans} values={values} components={components}>
      {children}
    </Trans>
  ) : null;
};

TranslationInterpolation.propTypes = {
  children: PropTypes.node,
  components: PropTypes.object,
  i18nKey: PropTypes.string.isRequired,
  values: PropTypes.object,
};

export default TranslationInterpolation;
